import { render, staticRenderFns } from "./SectorType.vue?vue&type=template&id=87fc66f4&scoped=true"
import script from "./SectorType.vue?vue&type=script&lang=js"
export * from "./SectorType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fc66f4",
  null
  
)

export default component.exports